
import createIcon from "./createIcon";

export const Heading1Icon = createIcon('Heading1', (props) => {
  return (
    <svg {...props}>
      <path d="M3.15 7.23L7.59 7.23L7.59 3.52L8.95 3.52L8.95 12.55L7.59 12.55L7.59 8.5L3.15 8.5L3.15 12.55L1.8 12.55L1.8 3.52L3.15 3.52L3.15 7.23ZM13.68 3.52L13.68 12.55L12.31 12.55L12.31 5.08L10.43 6.06L10.43 4.63L12.6 3.52L13.68 3.52Z" fill={props.color} fillOpacity="1" fillRule="evenodd" />
    </svg >
  )
});
